import { createRouter, createWebHistory } from 'vue-router';
import type { RouteRecordRaw } from 'vue-router';

const history = createWebHistory();

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/onboarding/verify',
    name: 'OnboardingVerify',
    meta: {
      title: '在线入职'
    },
    component: () => import('@/views/login/index.vue')
  },
  {
    path: '/onboarding/form',
    name: 'OnboardingForm',
    meta: {
      title: '基本信息填写'
    },
    component: () => import('@/views/onboarding/index.vue')
  },
  {
    path: '/onboarding/result',
    name: 'OnboardingResult',
    meta: {
      title: '申请成为代理人'
    },
    component: () => import('@/views/onboarding/result.vue')
  },
  {
    path: '/home',
    name: 'Home',
    meta: {
      title: '首页',
      keepAlive: true
    },
    component: () => import('@/views/home/index.vue')
  },
  {
    path: '/insurance-plan',
    name: 'InsurancePlan',
    meta: { title: '计划书' },
    children: [
      {
        path: 'client',
        name: 'PlanClientReader',
        meta: { title: '专属保障计划' },
        component: () => import('@/insurance-plan/views/client/index.vue')
      },
      {
        path: 'client-v2',
        name: 'PlanClientReaderV2',
        meta: { title: '专属保障计划' },
        component: () => import('@/insurance-plan/views/client/index.vue')
      },
      {
        path: 'list',
        name: 'PlanList',
        meta: { title: '计划书列表', keepAlive: true },
        component: () => import('@/insurance-plan/views/plan-list/index.vue')
      },
      {
        path: 'chuangke/list',
        name: 'MakerPlanList',
        meta: { title: '创客计划书列表', keepAlive: true },
        component: () => import('@/insurance-plan/views/maker-plan-list/index.vue')
      },
      {
        path: 'proposal-config',
        name: 'PlanConfig',
        meta: { title: '计划书配置' },
        component: () => import('@/insurance-plan/views/plan-config/index.vue')
      },
      {
        path: 'maker/proposal-config',
        name: 'MakerPlanConfig',
        meta: { title: '创客计划书配置' },
        component: () => import('@/insurance-plan/views/maker-plan-config/index.vue')
      },
      {
        path: 'points-calculate',
        name: 'PointsCalculate',
        meta: { title: '积分计算' },
        component: () => import('@/insurance-plan/views/points-calculate/index.vue')
      },
      {
        path: 'proposal',
        name: 'Proposal',
        meta: { title: '计划书预览' },
        component: () => import('@/insurance-plan/views/proposal/index.vue')
      },
      {
        path: 'market/proposal',
        name: 'MarketProposal',
        meta: { title: '创客计划书预览' },
        component: () => import('@/insurance-plan/views/market-proposal/index.vue')
      },
      {
        path: 'review',
        name: 'Review',
        meta: { title: '计划书审阅' },
        component: () => import('@/insurance-plan/views/review/index.vue')
      },
      {
        path: 'plan-behavior',
        name: 'PlanBehavior',
        meta: { title: '计划书' },
        component: () => import('@/insurance-plan/views/workbench/index.vue')
      },
      {
        path: 'legacy/plan-behavior',
        name: 'LegacyPlanBehavior',
        meta: { title: '原计划书' },
        component: () => import('@/insurance-plan/views/plan-behavior/index.vue')
      },
      {
        path: 'proposal-trace-list',
        name: 'ProposalTraceList',
        meta: { title: '轨迹查看' },
        component: () => import('@/insurance-plan/views/proposal-trace-list/index.vue')
      },
      {
        path: 'proposal-visitors',
        name: 'ProposalVisitors',
        meta: { title: '访客管理' },
        children: [
          {
            path: 'list',
            name: 'VisitorList',
            meta: { title: '全部访客' },
            component: () => import('@/insurance-plan/views/proposal-visitors/VisitorList.vue')
          },
          {
            path: 'detail',
            name: 'VisitorDetail',
            meta: { title: '访客详情' },
            component: () => import('@/insurance-plan/views/proposal-visitors/VisitorDetail.vue')
          }
        ]
      },
      {
        path: 'customer',
        name: 'Customer',
        meta: { title: '客户管理' },
        children: [
          {
            path: 'list',
            name: 'CustomerList',
            meta: { title: '关联客户' },
            component: () => import('@/insurance-plan/views/customer/CustomerList.vue')
          },
          {
            path: 'search',
            name: 'CustomerSearchHistory',
            meta: { title: '客户搜索' },
            component: () => import('@/insurance-plan/views/customer/CustomerSearchHistory.vue')
          },
          {
            path: 'search-result',
            name: 'CustomerSearchResult',
            meta: { title: '搜索结果' },
            component: () => import('@/insurance-plan/views/customer/CustomerSearchResult.vue')
          },
          {
            path: 'detail',
            name: 'CustomerDetail',
            meta: { title: '客户详情' },
            component: () => import('@/insurance-plan/views/customer/CustomerDetail.vue')
          }
        ]
      }
    ]
  },
  {
    path: '/user/card',
    name: 'UserCard',
    meta: {
      title: '我的名片'
    },
    component: () => import('@/views/user/card/index.vue')
  },
  {
    path: '/training/article/:id',
    name: 'TrainingArticleDetail',
    meta: {
      title: '文章详情'
    },
    component: () => import('@/views/training/article/index.vue')
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    meta: {
      title: '页面不存在'
    },
    component: () => import('@/views/not-found/index.vue')
  }
];

const router = createRouter({
  history,
  routes
});

const STATUS_BAR_KEY = 'app_statusBarHeight';
const initialH = new URLSearchParams(location.search).get('statusBarHeight');
if (initialH) sessionStorage.setItem(STATUS_BAR_KEY, initialH);

router.beforeEach((to, _from, next) => {
  const token = new URLSearchParams(window.location.search).get('token');
  if (token) {
    localStorage.setItem('app_token', token);
  }
  if (to.meta.title) {
    document.title = to.meta.title as string;
  }
  if (to.path.startsWith('/insurance-plan')) {
    const h =
      new URLSearchParams(location.search).get('statusBarHeight') ||
      sessionStorage.getItem(STATUS_BAR_KEY);
    document.body.style.paddingTop = h ? `${h}px` : '';
  } else {
    document.body.style.paddingTop = '';
  }
  next();
});

router.afterEach(() => {
  window.scrollTo(0, 0);
});

export default router;
